import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "./baseQuery";

interface DiscountResponse {
  data: Discount[];
}

interface Discount {
  id?: string;
  name?: string;
  description?: string;
  percentage?: number;
  type?: number;
  discount?: number;
}

export const discountApi = createApi({
  reducerPath: "discountApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getDiscounts: builder.query<DiscountResponse, void>({
      query: () => ({
        url: "/settings/discounts",
        method: "GET",
      }),
    }),
    updateDiscount: builder.mutation<Discount, Discount>({
      query: (discount) => ({
        url: `/settings/discounts`,
        method: "PUT",
        body: JSON.stringify(discount),
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const { useGetDiscountsQuery, useUpdateDiscountMutation } = discountApi;
